import { FileModel } from '../../app/core/models/file-model.model';
import { ListSearch } from '../../app/core/models/list-search.model';
import { SortOption } from '../../app/core/types/sort-option.type';
import * as FileUtils from '../file/file-utils';

export function getShownFilesBySearchAndSortOptions(selectedFiles: FileModel[], searchOptions?: ListSearch): FileModel[] {
    let filteredFiles: FileModel[] = [...selectedFiles];

    if (searchOptions != null) {
        // Apply search term
        if (searchOptions.searchQuery.length > 0) {
            filteredFiles = [...filteredFiles.filter((file: FileModel) => file.name.toLowerCase().indexOf(searchOptions.searchQuery.toLowerCase()) > -1)];
        }

        // Apply sorting on complete list since the order in which files are sent to the workflow engine is important
        if (searchOptions.sortBy != null && searchOptions.sortBy !== '') {
            const sortedFiles: FileModel[] = getSortedFileset([...filteredFiles], searchOptions.sortBy);
            filteredFiles = [...sortedFiles];
        }
    }

    return filteredFiles;
}

/**
 * Get files of the current page.
 *
 * @param filteredFiles - pass in the files you want to page. Normally it's the already filtered/sorted files
 */
export function getCurrentPageOfFiles(filteredFiles: FileModel[], searchOptions?: ListSearch): FileModel[] {
    filteredFiles = [...filteredFiles];

    if (searchOptions != null) {
        // apply pagination
        const pageSize = searchOptions.pageSize;
        const pageNumber = searchOptions.pageNumber;

        const startIndex = (pageNumber - 1) * pageSize;
        const endIndex = pageNumber * pageSize;

        filteredFiles = [...filteredFiles.slice(startIndex, endIndex)];
    }

    return filteredFiles;
}

function getSortedFileset(files: FileModel[], sortOptionValue: SortOption | undefined): FileModel[] {
    if (sortOptionValue != null && sortOptionValue !== '') {
        if (sortOptionValue.indexOf('name') > -1) {
            files = sortFilesByName(files, sortOptionValue);
        } else if (sortOptionValue.toLocaleLowerCase().indexOf('date') > -1 || sortOptionValue.indexOf('createdAt') > -1) {
            files = sortFilesByDate(files, sortOptionValue);
        }
    }

    return files;
}

function sortFilesByName(files: FileModel[], sort: string): FileModel[] {
    return files.sort((f1, f2) => sortStrings(f1.name || f1.token, f2.name || f2.token, sort === 'name' ? 'asc' : 'desc'));
}

function sortFilesByDate(files: FileModel[], sort: string): FileModel[] {
    return files.sort((f1, f2) => {
        const f1CreatedDate = f1.createdAt ? new Date(f1.createdAt) : new Date();
        const f2CreatedDate = f2.createdAt ? new Date(f2.createdAt) : new Date();
        if (sort === '-date' || sort === '-createdAt') {
            return f2CreatedDate > f1CreatedDate ? 1 : f2CreatedDate === f1CreatedDate ? sortStrings(f1.token || f1.name, f2.token || f2.name, 'asc') : -1;
        } else {
            return f1CreatedDate > f2CreatedDate ? 1 : f1CreatedDate === f2CreatedDate ? sortStrings(f1.token || f1.name, f2.token || f2.name, 'asc') : -1;
        }
    });
}

function sortStrings(file1Location: string, file2Location: string, order: 'asc' | 'desc') {
    const f1Name = decodeURIComponent(FileUtils.getFileNameWithExtension(file1Location)).toLowerCase();
    const f2Name = decodeURIComponent(FileUtils.getFileNameWithExtension(file2Location)).toLowerCase();
    if (order === 'desc') {
        return f1Name < f2Name ? 1 : f1Name === f2Name ? 0 : -1;
    } else {
        return f1Name > f2Name ? 1 : f1Name === f2Name ? 0 : -1;
    }
}
